import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const CONNECT_BY = 'connectBy';
const WALLET_PARAM = 'wallet';

interface IUseConnectWalletScreen {
  isWalletSelectionActive: boolean;
  onOpenConnectWallet: () => void;
  onBackButtonClick: () => void;
}

export function useConnectWalletScreen(): IUseConnectWalletScreen {
  const [searchParams, setSearchParams] = useSearchParams();

  const isWalletSelectionActive = searchParams.get(CONNECT_BY) === WALLET_PARAM;

  const onOpenConnectWallet = useCallback(() => {
    searchParams.set(CONNECT_BY, WALLET_PARAM);
    setSearchParams(searchParams, { replace: false });
  }, [searchParams, setSearchParams]);

  const onBackButtonClick = useCallback(() => {
    searchParams.delete(CONNECT_BY);
    setSearchParams(searchParams, { replace: false });
  }, [searchParams, setSearchParams]);

  return {
    isWalletSelectionActive,
    onOpenConnectWallet,
    onBackButtonClick,
  };
}
